import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import hash from 'object-hash';
import { FormattedMessage } from 'react-intl';
import { Cell, TableRow, Table, TableHeader } from 'components/ui/StyledTable';

const DATE_DISPLAY_FORMAT = 'YYYY-MM-DD';

const DiscountCodesTable = ({ discountCodes }) => (
  <Table data-cy="discount-codes-table">
    <TableHeader columns={10}>
      <Cell span={2}>
        <FormattedMessage id="discountCodes.reference" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="discountCodes.status" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="discountCodes.type" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="discountCodes.currency" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="discountCodes.originalValue" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.salesPeriodStart" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.salesPeriodEnd" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.travelPeriodStart" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.travelPeriodEnd" />
      </Cell>
    </TableHeader>
    {discountCodes.map((t) => (
      <TableRow columns={10} key={hash(t)} data-cy="discount-codes-content">
        <Cell alignItems="center" span={2} data-cy="cell">
          <Link to={`/discountCodes/${t.alias}`}>{t.reference}</Link>
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.isActive ? 'Active' : 'Inactive'}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.valueType}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.currency}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.valueType === 'PERCENTAGE' ? `${t.value.toString()}%` : parseFloat(t.value).toFixed(2)}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.salesPeriodStart).format(DATE_DISPLAY_FORMAT)}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.salesPeriodEnd).format(DATE_DISPLAY_FORMAT)}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.travelPeriodStart).format(DATE_DISPLAY_FORMAT)}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.travelPeriodEnd).format(DATE_DISPLAY_FORMAT)}
        </Cell>
      </TableRow>
    ))}
  </Table>
);

DiscountCodesTable.propTypes = {
  discountCodes: PropTypes.arrayOf(PropTypes.object)
};

export default DiscountCodesTable;
